import SelectNumberNullable from "../components/SelectNumberNullable";
import React, {useContext, useEffect, useState} from "react";
import AppContext from "./appContext";
import NumberNullable from "../components/NumberNullable";

export interface ScissorFilter {
    id: number | null,
}

export function emptyScissorFilter(): ScissorFilter {
    return {
        id: null,
    }
}

const XMarkIcon: React.FC<{ 
    className: string, 
    onClick: () => void 
}> = (props)=> {
    return <svg onClick={props.onClick} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" className={props.className}>
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
    </svg>

}

const ScissorSearchFilter: React.FC<{
    show: boolean;
    onSearch: (filter: ScissorFilter) => void;
    onClose: () => void;
    reset: () => void;
}> = (props) => {
    const context = useContext(AppContext)

    const [filter, setFilter] = useState<ScissorFilter>(emptyScissorFilter())

    function filterBy(field: Partial<ScissorFilter>) {
        setFilter({
            ...filter,
            ...field
        })
    }

    if (props.show) {
        return <div className="text-white p-4 shadow-md absolute z-50 bg-white mt-1">

            <div className="text-right">
                <XMarkIcon className="cursor-pointer inline-block w-6 h-6 text-gray-400"
                           onClick={() => props.onClose()}/>
            </div>

            <table className="w-full text-gray-600">
                <tr>
                    <td className="pl-4 pr-8">Id</td>
                    <td className="py-1">
                        <NumberNullable 
                            value={filter.id} 
                            onEnter={() => props.onSearch(filter)}
                            change={v => {
                            filterBy({id: v})
                        }}/>
                    </td>
                </tr>
            </table>

            <div className="text-right mt-2">
                <div className="inline-block px-4 cursor-pointer text-gray-600" onClick={() => {
                    setFilter(emptyScissorFilter())
                    props.reset()
                }}>reset
                </div>
                <div className="btn bg-primary-500" onClick={() => props.onSearch(filter)}>search</div>
            </div>

        </div>
    }
    return <></>
}

export default ScissorSearchFilter